import { getMomentTz } from "@dexteel/mesf-core";
import { Typography } from "@mui/material";
import { CONSUMPTION_CAPTION_SX } from "../utils/tokens";

const moment = getMomentTz();

const formatRelativeTime = (value: Date, now: Date) => {
	const elapsedMinutes = Math.floor((now.getTime() - value.getTime()) / 60_000);
	if (elapsedMinutes < 1) return "just now";
	if (elapsedMinutes < 60) return `${elapsedMinutes} min ago`;
	if (elapsedMinutes < 1440) return `${Math.floor(elapsedMinutes / 60)} h ago`;
	return `${Math.floor(elapsedMinutes / 1440)} d ago`;
};

/**
 * How far the readings have been through, stated by the dashboard that read them: each
 * utility has its own feed, and its own cut.
 */
export const DataThroughCaption = ({
	dataThroughUtc,
	label = "Data through",
}: {
	dataThroughUtc: Date | null;
	label?: string;
}) =>
	dataThroughUtc === null ? null : (
		<Typography component="div" sx={CONSUMPTION_CAPTION_SX}>
			{label} {moment(dataThroughUtc).format("MMM D, YYYY HH:mm")} ·{" "}
			{formatRelativeTime(dataThroughUtc, new Date())}
		</Typography>
	);
